import React from "react";
import LoginForm from "../components/forms/loginForm/LoginForm";
import LayoutWrapper from "../layout/layoutWrapper/LayoutWrapper";
import { Helmet } from "react-helmet";


const Login = () => {
  return (
    <>
        <Helmet>
  <title>Login to Your Inkox Account to Access Orders and Designs
</title>
  <meta name="description" content="Log in to your Inkox account to continue designing, manage your orders, and view past
purchases" />
</Helmet>
    <LayoutWrapper>

    <div className="login">
      <LoginForm />
  
    </div>
    </LayoutWrapper>
    </>

  );
};

export default Login;
